import React from 'react';
import { PointCard } from '../../point';

function CataloguePointRow() {
  return (
    <div className="flex flex-col justify-center items-start w-[50%] space-y-5">
      <h4 className=" text-neutral-cold-800 text-lg lg:text-xl text-left font-semibold">
        Puntos prepagados
      </h4>
      <PointCard />
    </div>
  );
}

export default CataloguePointRow;
